import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";  // 🔹 Importar para obtener CSRF Token
import Pagination from "../components/Pagination";

function ListaContactos() {
  const [contactos, setContactos] = useState([]);  // Asegurar que es un array
  const [persona, setPersona] = useState("");
  const [telefono, setTelefono] = useState("");
  const [activo, setActivo] = useState(true); 
  const [editando, setEditando] = useState(null);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(10);

// 🔎 Función para filtrar contactos por nombre o teléfono
const buscarContactos = () => {
  obtenerContactos(`${API_URL}/api/contactos/?search=${searchTerm}&page_size=10`);
};
 
  const API_URL = process.env.REACT_APP_BACKEND_URL; // `${API_URL}/api/`
  const obtenerContactos = useCallback((url = `${API_URL}/api/contactos/?page_size=${pageSize}`) => {
    axios.get(url)
      .then(response => {
        const data = response.data.results || [];
        // Orden natural por nombre
        const ordenados = [...data].sort((a, b) => a.persona.localeCompare(b.persona, 'es', { sensitivity: 'base' }));
        setContactos(ordenados);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      })
      .catch(error => {
        console.error("Error al obtener los contactos:", error);
        setContactos([]);
      });
  }, [API_URL, pageSize]);
  

  useEffect(() => {
    obtenerContactos();
  }, [pageSize, obtenerContactos]);

  const agregarContacto = (event) => {
    event.preventDefault();
  
    // Verificar si ya existe un contacto con el mismo nombre (ignorando mayúsculas y espacios)
    const existeNombre = contactos.some(c => 
      c.persona.trim().toLowerCase() === persona.trim().toLowerCase() &&
      (!editando || c.id !== editando)
    );
  
    if (existeNombre) {
      alert("❌ Ya existe un contacto con ese nombre. Por favor elige otro.");
      return; // ⛔ Cancelar guardado
    }
  
    const nuevoContacto = { persona, telefono, activo };
    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      withCredentials: true,
    };
  
    if (editando) {
      axios.put(`${API_URL}/api/contactos/${editando}/`, nuevoContacto, config)
        .then(() => {
          obtenerContactos();
          setEditando(null);
        })
        .catch(error => console.error("❌ Error al editar contacto:", error));
    } else {
      axios.post(`${API_URL}/api/contactos/`, nuevoContacto, config)
        .then(() => {
          obtenerContactos();
        })
        .catch(error => console.error("❌ Error al agregar contacto:", error));
    }
  
    // ✅ Limpieza del formulario
    setPersona("");
    setTelefono("");
    setActivo(true);
  };
  
  // 🔹 Cambiar estado activo de un contacto
  const toggleActivo = (id, estadoActual) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      withCredentials: true,
    };

    axios.patch(`${API_URL}/api/contactos/${id}/`, { activo: !estadoActual }, config)
      .then(() => {
        obtenerContactos();
      })
      .catch(error => console.error("❌ Error al cambiar estado de contacto:", error));
  };
  return (
    <div>
      <h3>Gestión de Contactos</h3>
      <div className="contenedor">
        <form onSubmit={agregarContacto} className="d-flex align-items-center gap-2 flex-wrap">
          <input
            type="text"
            placeholder="Nombre"
            value={persona}
            maxLength={15}
            onChange={(e) => setPersona(e.target.value)}
            required
            style={{ width: "150px" }}
          />
          <input
            type="text"
            placeholder="Teléfono"
            value={telefono}
            maxLength={15}
            onChange={(e) => setTelefono(e.target.value)}
            required
            style={{ width: "150px" }}
          />
          <label className="form-check-label d-flex align-items-center gap-1">
            <input
              type="checkbox"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
            Activo
          </label>
          <button type="submit" className="btn btn-primary">
            {editando ? "Actualizar" : "Agregar"} Contacto
          </button>
        </form>
      </div>

      
      <div className="contenedor">
        {/* 🔎 Búsqueda */}
        <div className="d-flex align-items-center gap-2 mt-3 flex-wrap">
          <label htmlFor="pageSizeSelect" className="form-label">Registros:</label>
          <select
            id="pageSizeSelect"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="form-select"
            style={{ width: "100px" }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </select>
          <input
            type="text"
            className="form-control"
            placeholder="Buscar..."
            value={searchTerm}
            maxLength={15}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "150px" }}
          />
          <button className="btn btn-primary" onClick={buscarContactos}>
            Buscar
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Activo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(contactos) && contactos.length > 0 ? (
              contactos
              .sort((a, b) => a.persona.localeCompare(b.persona, undefined, { sensitivity: 'base' }))
              .map(contacto => (
                <tr key={contacto.id}>
                  <td>{contacto.persona}</td>
                  <td>{contacto.telefono}</td>
                  <td>
                    <input 
                      type="checkbox" 
                      checked={contacto.activo} 
                      onChange={() => toggleActivo(contacto.id, contacto.activo)} 
                    />
                  </td>
                  <td>
                    <button onClick={() => { 
                      setEditando(contacto.id); 
                      setPersona(contacto.persona); 
                      setTelefono(contacto.telefono);
                      setActivo(contacto.activo);
                    }}>Editar</button>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        if (window.confirm("¿Estás seguro que quieres eliminar este contacto?")) {
                          axios.delete(`${API_URL}/api/contactos/${contacto.id}/`, {
                            headers: {
                              "X-CSRFToken": Cookies.get("csrftoken"),
                            },
                            withCredentials: true,
                          })
                            .then(() => {
                              obtenerContactos();
                            })
                            .catch(error => console.error("❌ Error al eliminar contacto:", error));
                        }
                      }}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No hay contactos disponibles.</td>
              </tr>
            )}
          </tbody>
        </table>
        {/* 🔹 Paginación Reutilizable */}
        <Pagination
          prevPage={prevPage}
          nextPage={nextPage}
          fetchPage={obtenerContactos}
        />
      </div>
    </div>
  );
}

export default ListaContactos;